import React from 'react'

function Practice() {
  return (
    <div>Practice</div>
  )
}

export default Practice